import { FeatureFlags } from "@appetize/iw-common/interfaces/featureFlags/featureFlags";
import { getDefaultState } from "./state";
import { FeatureFlagsState } from "./interfaces";

export const setFeatureFlags = (state: FeatureFlagsState, featureFlags: FeatureFlags) => {
  state.featureFlags = featureFlags;
};
export const resetState = (state: FeatureFlagsState) => {
  Object.assign(state, getDefaultState());
};
